import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from "@mui/material";
const CommonDialog = ({ open, onClose, title, message, type = "info" }) => {
  const getColor = () => {
    switch (type) {
      case "success":
        return "green";
      case "error":
        return "red";
      case "warning":
        return "orange";
      default:
        return "black";
    }
  };

  return(
    <Dialog
    open={open}
    onClose={onClose}
    fullWidth
    maxWidth="xs">

    <DialogTitle sx={{color:getColor()}}>
    {title}
    </DialogTitle>
<DialogContent>
    <Typography sx={{fontSize:"16px", overflowWrap:"anywhere"}}>{message}</Typography>

</DialogContent>
<DialogActions>
    <Button onClick={onClose} variant="contained" color="primary">
        OK
    </Button>
</DialogActions>
    </Dialog>
  )
};

export default CommonDialog;
